import type { BuyChapterTabProps } from './interface'
import cn from 'classnames'
import Image from 'next/image'
import { Button } from '@components/Buttons'
import CoinButton from '@components/CoinButton'
import { addComma } from '@lib/utils'

export const BuyChapterTab = ({
  className,
  disabled,
  chapters,
  handleCancel,
  handleBuyChapter,
}: BuyChapterTabProps) => {
  return (
    <div
      className={cn(
        'mb-6 flex flex-col items-center justify-between w-full px-4 py-6 space-y-3 desktop-tablet:flex-row border bg-white border-gray-4 shadow-card rounded-[8px] desktop-tablet:space-y-0',
        className
      )}
    >
      <div className='flex items-center justify-between w-full space-x-5 desktop-tablet:justify-start'>
        <p className='text-left'>
          เลือกตอน ({addComma(chapters?.length ?? 0)})
        </p>
        <div className='flex items-center space-x-2'>
          <div className='relative'>
            <Image src='/coin.webp' width='24' height='24' />
          </div>
          <p className='font-bold text-coin'>
            {addComma(chapters?.reduce((acc, c) => acc + c.price, 0) ?? 0)}
          </p>
        </div>
      </div>
      <div className='flex justify-between w-full space-x-4 desktop-tablet:justify-end'>
        <Button
          className='text-secondary-1 text-[14px] font-medium border border-secondary-1'
          type='button'
          onClick={handleCancel}
        >
          ยกเลิก
        </Button>
        <CoinButton
          className='w-[200px]'
          secondClassName='h-[40px]'
          type='submit'
          disabled={disabled}
          data-test='submit-buy-chapter'
          size={40}
          onClick={() => handleBuyChapter(chapters)}
        >
          ยืนยันการซื้อ
        </CoinButton>
      </div>
    </div>
  )
}
